var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container-fluid" }, [
    !_vm.loading
      ? _c(
          "div",
          { staticClass: "carrier-dashboard" },
          [
            _c(
              "div",
              { staticClass: "graph-container" },
              [
                _c(
                  "el-row",
                  { attrs: { type: "flex", gutter: 12 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 10 } },
                      [
                        _c(
                          "el-row",
                          { attrs: { type: "flex", gutter: 12 } },
                          [
                            _c(
                              "el-col",
                              { attrs: { xs: 24, sm: 24, md: 24 } },
                              [
                                _c(
                                  "el-card",
                                  {
                                    staticClass: "min-vh-150px",
                                    attrs: { shadow: "always" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "clearfix",
                                        attrs: { slot: "header" },
                                        slot: "header",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("dashboard.filter"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c("el-date-picker", {
                                      staticClass: "w-100",
                                      attrs: {
                                        type: "date",
                                        clearable: false,
                                        placeholder: _vm.$t("dateRange.date"),
                                        "value-format": "yyyy-MM-dd",
                                        "picker-options": { firstDayOfWeek: 7 },
                                      },
                                      on: { change: _vm.handlePlanDateChanges },
                                      model: {
                                        value: _vm.$planDate,
                                        callback: function ($$v) {
                                          _vm.$planDate = $$v
                                        },
                                        expression: "$planDate",
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { xs: 24, sm: 24, md: 24 } },
                              [
                                _c(
                                  "el-card",
                                  {
                                    staticClass: "min-vh-150px",
                                    attrs: { shadow: "always" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "clearfix",
                                        attrs: { slot: "header" },
                                        slot: "header",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.$t("general.search"))
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c(
                                      "el-form",
                                      {
                                        attrs: {
                                          "label-position": "top",
                                          "label-width": "8em",
                                          inline: true,
                                          size: "large",
                                        },
                                      },
                                      [
                                        _c(
                                          "el-form-item",
                                          { staticStyle: { width: "125px" } },
                                          [
                                            _c(
                                              "el-select",
                                              {
                                                attrs: {
                                                  filterable: "",
                                                  placeholder: _vm.$t(
                                                    "planning.placeholder.searchFilter"
                                                  ),
                                                },
                                                on: {
                                                  change: function ($event) {
                                                    _vm.searchText = ""
                                                  },
                                                },
                                                model: {
                                                  value: _vm.searchFilter,
                                                  callback: function ($$v) {
                                                    _vm.searchFilter = $$v
                                                  },
                                                  expression: "searchFilter",
                                                },
                                              },
                                              _vm._l(
                                                ["planId", "shipmentReference"],
                                                function (item, index) {
                                                  return _c("el-option", {
                                                    key: item,
                                                    attrs: {
                                                      label: _vm.$t(
                                                        "planning.columns." +
                                                          item
                                                      ),
                                                      value: item,
                                                    },
                                                  })
                                                }
                                              ),
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-form-item",
                                          {
                                            staticStyle: {
                                              width: "calc(100% - 140px)",
                                            },
                                          },
                                          [
                                            _c("el-input", {
                                              attrs: {
                                                clearable: "",
                                                placeholder: _vm.$t(
                                                  "planning.placeholder.searchQuery"
                                                ),
                                              },
                                              nativeOn: {
                                                keyup: function ($event) {
                                                  if (
                                                    !$event.type.indexOf(
                                                      "key"
                                                    ) &&
                                                    _vm._k(
                                                      $event.keyCode,
                                                      "enter",
                                                      13,
                                                      $event.key,
                                                      "Enter"
                                                    )
                                                  ) {
                                                    return null
                                                  }
                                                  return _vm.searchTruck.apply(
                                                    null,
                                                    arguments
                                                  )
                                                },
                                              },
                                              model: {
                                                value: _vm.searchText,
                                                callback: function ($$v) {
                                                  _vm.searchText = $$v
                                                },
                                                expression: "searchText",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { xs: 12, sm: 12, md: 12 } },
                              [
                                _c(
                                  "el-card",
                                  {
                                    staticClass:
                                      "min-vh-150px number-count-card",
                                    attrs: { shadow: "always" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "clearfix",
                                        attrs: { slot: "header" },
                                        slot: "header",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dashboard.availableOrderCount"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c("number-count", {
                                      attrs: {
                                        number:
                                          _vm.dashboardDataSummary
                                            .availableOrder || 0,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "el-col",
                              { attrs: { xs: 12, sm: 12, md: 12 } },
                              [
                                _c(
                                  "el-card",
                                  {
                                    staticClass:
                                      "min-vh-150px number-count-card",
                                    attrs: { shadow: "always" },
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "clearfix",
                                        attrs: { slot: "header" },
                                        slot: "header",
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "dashboard.completedOrderCount"
                                              )
                                            )
                                          ),
                                        ]),
                                      ]
                                    ),
                                    _c("number-count", {
                                      attrs: {
                                        number:
                                          _vm.dashboardDataSummary
                                            .completedOrder || 0,
                                      },
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { xs: 24, sm: 24, md: 14 } },
                      [
                        _c(
                          "el-card",
                          {
                            staticClass: "min-vh-150px",
                            attrs: { shadow: "always" },
                          },
                          [
                            _c("map-world", {
                              ref: "heatMap",
                              attrs: {
                                locations: _vm.locations,
                                routes: _vm.dashboardDataSummary.latlngHeatMap,
                                "init-event": "heatmap",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._l(_vm.dashboardData, function (route, index) {
              return _c(
                "div",
                { key: index, staticClass: "gantt-chart-container margin-n" },
                [
                  _c(
                    "el-card",
                    {
                      staticClass: "min-vh-150px",
                      attrs: { shadow: "always" },
                    },
                    [
                      _c("p", { staticClass: "gantt-chart-header" }, [
                        _vm._v(
                          _vm._s(
                            route.key["company"] ? route.key["company"] : "None"
                          )
                        ),
                      ]),
                      _c("mini-gantt-chart", {
                        attrs: {
                          routing: route.routing,
                          date: _vm.$planDate,
                          allCompany: true,
                          index: index,
                          highlightedTruckId: _vm.sTruck,
                          ganttChartHeight: 300,
                        },
                        on: { selectedFunction: _vm.updateMarker },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
          ],
          2
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }